import { toast } from 'sonner';

import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Paragraph } from '../models/paragraph';
import { getParagraphByIdEndpoint } from './const';

export const getParagraphById = async (id: string): Promise<Paragraph> => {
    try {
        const response = await getHttpClient().get<Paragraph>({ url: `${getParagraphByIdEndpoint}/${id}` });

        if (response) {
            return response;
        }

        toast.error('Brak danych.');
        throw new Error('No paragraphs data received.');
    } catch (error) {
        toast.error(`Błąd podczas pobierania danych: ${error}`);
        throw error;
    }
};
